<template>
  <div class="grid grid-rows-2 w-full m-auto items-center font-[Electrolize]">
    <section class="px-5 hidden md:flex">
      <ul
        class="divide-x divide-white text-gray-300 py-2 xl:w-2/4 ml-auto mr-0 flex flex-row justify-end text-[10px] uppercase items-center"
      >
        <li class="px-3">
          <router-link to="/about" class="">ABOUT</router-link>
        </li>
        <li class="px-3">
          <router-link to="/whats-new" class=""
            >WHAT'S NEW<span
              v-if="recent"
              class="ml-1 px-1 rounded-sm bg-[#FF0000] text-white text-[8px] align-middle"
              >NEW</span
            ></router-link
          >
        </li>
        <li class="px-3">
          <router-link to="/timing-scoring" class=""
            >TIMING &amp; SCORING</router-link
          >
        </li>
        <li class="px-3">
          <a
            target="_blank"
            rel="noopener"
            href="http://www.rallymotoshop.com/"
            class=""
            >RALLY NAVIGATION EQUIPMENT</a
          >
        </li>
        <li class="px-3">
          <a
            target="_blank"
            rel="noopener"
            href="http://advrider.com/index.php?threads/rally-navigator-create-rally-roadbooks-with-google-earth-and-gps.851881/"
            class=""
            >FORUM</a
          >
        </li>
        <li class="px-3">
          <router-link to="/mobile-roadbook-reader" class=""
            >MOBILE ROADBOOK READER</router-link
          >
        </li>
      </ul>
    </section>
    <section
      class="hidden md:flex text-gray-300 bg-[#33343D] justify-between px-2 md:px-5"
    >
      <router-link to="/">
        <picture class="contents">
          <source srcset="/images/logo-trans-small-235x58.webp" type="image/webp" />
          <img
          width="207"
          height="57"
          src="/images/logo-trans-small-235x58.png"
          class="xl:-mt-[10px]"
          />
        </picture>
      </router-link>
      <ul
        class="flex flex-r divide-x divide-white uppercase items-center text-sm xl:text-base py-2 xl:py-0"
      >
        <li class="px-3 hover:text-white">
          <router-link to="/download" class="download"
            >DOWNLOAD RALLY NAVIGATOR</router-link
          >
        </li>
        <li class="px-3 hover:text-white">
          <router-link to="/rally-roadbook">Rally Roadbook</router-link>
        </li>
        <li class="px-3 relative flex group z-10">
          <span aria-haspopup="true" aria-expanded="false">Cross Country</span>
          <ul
            class="absolute bg-[#1A1A1A] w-[220px] translate-y-6 -translate-x-12 hidden group-hover:grid grid-rows-2 gap-2 shadow-lg transform transition-all duration-30000 ease-in-out"
          >
            <li
              class="px-3 py-2 hover:bg-[#FF0000] hover:text-white flex items-center"
            >
              <router-link to="/how-to-create-a-cross-country"
                >How to Create Cross Country Roadbook</router-link
              >
            </li>
            <li
              class="px-3 py-2 hover:bg-[#FF0000] hover:text-white flex items-center"
            >
              <router-link to="/fim-fia-roadbook-specs-rules"
                >Cross Country FIA Roadbook Specs &amp; Rules</router-link
              >
            </li>
          </ul>
        </li>
        <li class="px-3 relative flex group z-10">
          <div class="hfe-has-submenu-container">
            <span aria-haspopup="true" aria-expanded="false"
              >Road &amp; Stage
            </span>
          </div>
          <ul
            class="absolute bg-[#1A1A1A] w-[220px] translate-y-6 -translate-x-12 hidden group-hover:grid grid-rows-2 gap-2 shadow-lg transform transition-all duration-30000 ease-in-out"
          >
            <li
              class="px-3 py-2 hover:bg-[#FF0000] hover:text-white flex items-center"
            >
              <router-link to="/how-to-create-a-road-rally"
                >How to Create Road Rally Roadbook</router-link
              >
            </li>
            <li
              class="px-3 py-2 hover:bg-[#FF0000] hover:text-white flex items-center"
            >
              <router-link to="/fia-roadbook-specs-rules"
                >Road Rally FIA Roadbook Specs &amp; Rules</router-link
              >
            </li>
          </ul>
        </li>
        <li class="px-3">
          <router-link to="/time-speed-distance"
            >Time Speed Distance</router-link
          >
        </li>
        <li class="px-3 hover:text-white">
          <router-link to="/pro-features">Pro Features</router-link>
        </li>
        <!-- <li class="flex h-full px-3 items-center">
          <router-link to="/subscriptions">Upgrade</router-link>
        </li> -->
      </ul>
    </section>
  </div>
</template>

<script>
import { hasRecentRelease } from '../content/releases';

export default {
  name: 'NavBar',
  computed: {
    // "New" badge on What's New for a few weeks after each release.
    recent: () => hasRecentRelease(),
  },
};
</script>

<style scoped>
.download {
  text-shadow: 1px 1px 2px black, 0 0 25px red, 0 0 5px darkred !important;
  font-weight: bold !important;
}
</style>
